import React from 'react'
import { Tooltip, Box, useTheme } from '@mui/material'
import InfoOutlineIcon from '@mui/icons-material/InfoOutlined'
interface DescriptionTooltipLabelProps {
  content: string
}

const NotesTooltip: React.FC<DescriptionTooltipLabelProps> = ({ content }) => {
  const theme = useTheme()

  return (
    <Tooltip
      title={
        <>
          {content && content !== '<p></p>' ? (
            <Box
              dangerouslySetInnerHTML={{ __html: content }}
              style={{
                width: '100%',
                minWidth: '500px',
                display: 'flex',
                flexDirection: 'column',
                color: theme.palette.text.primary,
                fontSize: '0.875rem',
                lineHeight: '1.4em',
              }}
            />
          ) : (
            ''
          )}
        </>
      }
      arrow
      placement="top-end"
      slotProps={{
        tooltip: {
          sx: {
            maxWidth: '600px',
            backgroundColor: 'background.tooltip',
            color: 'text.primary',
            padding: '16px',
            borderRadius: '8px',
            textAlign: 'left',
          },
        },
        arrow: {
          sx: {
            color: 'background.tooltip',
          },
        },
      }}
    >
      <InfoOutlineIcon
        sx={{
          cursor: 'default',
          color: content && content !== '<p></p>' ? 'text.primary' : 'text.disabled',
          '&:hover': { color: content && content !== '<p></p>' ? 'text.highlight' : 'text.disabled' },
        }}
        fontSize="small"
      />
    </Tooltip>
  )
}

export default NotesTooltip
